import Vue from 'vue';
import Index from './index.vue';
import http from '@/http'
let ComponentConstructor = Vue.extend(Index);
let instance;

// Customer/Components/attachment
let Component =  function(single,acceptType,routePath,queryOption,callback) {
	instance = new ComponentConstructor({
		data: {
      single,
      acceptType,
      uploadOptions: {
        target: http.defaults.baseURL + routePath,
        chunkSize:10*1024*1024,
        testChunks:true,
        simultaneousUploads:5,
        checkChunkUploadedByResponse: function (chunk, message) {
          var objMessage = {}
          try {
            objMessage = JSON.parse(message)
          } catch (e) {}
          return (objMessage.uploaded_chunks || []).indexOf(chunk.offset + 1) >= 0
        },
        query:queryOption,
        headers:{ Authorization: `Bearer ${sessionStorage.token ||localStorage.token|| ""}`}
      },
    }
	});
	instance.$mount();
	instance.callback = callback;
	document.body.appendChild(instance.$el);
	instance.visible = true;
	return instance;
}

export default Component;
